import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "Pages/Home/Home";
import About from "Pages/About/About";
import Clients from "Pages/Clients/Clients";
import Partners from "Pages/Partner/Partners";
import Certificates from "Pages/Certificates/Certificates";
import Projects from "Pages/Projects/Projects";
import ServiceDetailes from "Pages/ServiceDetailes/ServiceDetailes";
import Contact from "Pages/Contact/Contact";
import Resources from "Pages/Resources/Resources.jsx";

import Header from "Layout/Header/Header";
import Footer from "Layout/Footer/Footer";
import { useTranslation } from "react-i18next";
import ScrollToTop from "Helpers/ScrollToTop";

import "i18n/i18n";

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateFontClass = () => {
      const htmlElement = document.documentElement;
      const currentLanguage = i18n.language;

      if (currentLanguage === "ar") {
        htmlElement.classList.add("arabic");
      } else {
        htmlElement.classList.remove("arabic");
      }
    };

    // Update font class on load
    updateFontClass();

    // Listen for language change
    i18n.on("languageChanged", updateFontClass);

    // Cleanup listener on unmount
    return () => {
      i18n.off("languageChanged", updateFontClass);
    };
  }, []);
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="about-us" element={<About />} />
        <Route path="clients" element={<Clients />} />
        <Route path="partners" element={<Partners />} />
        <Route path="projects" element={<Projects />} />
        <Route path="contact-us" element={<Contact />} />
        <Route path="certificates" element={<Certificates />} />
        <Route path="resources" element={<Resources />} />
        <Route path="serviceDetailes/:slug" element={<ServiceDetailes />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
